import { Component, Input } from '@angular/core';
import { ICardLink } from '@app/models/signup';

@Component({
  selector: 'signup-card-link',
  templateUrl: './signup-card-link.component.html',
  styleUrls: ['./signup-card-link.component.scss']
})
export class SignupCardLinkComponent {
  @Input() data: ICardLink;
  @Input() modeButton = false;

  constructor() {

  }

  goToLink(link:string):void {
    window.location.href = link ? link : window['ENDPOINTS'].manager;
  }

}
